import classNames from "classnames";
import React from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import styles from "./styles.module.css";

interface Props {
  content: Array<{
    title: string;
    content: React.ReactNode;
  }>;
  tabListContainerClassName?: string;
  extraTabListClassName?: string;
  extraTabPanelClassName?: string;
}

export const SimpleTabs: React.FC<React.PropsWithChildren<Props>> = ({
  content,
  tabListContainerClassName,
  extraTabListClassName,
  extraTabPanelClassName,
}) => {
  return (
    <Tabs>
      <div className={tabListContainerClassName}>
        <TabList className={classNames(styles.tabList, extraTabListClassName)}>
          {content.map((item, idx) => (
            <Tab
              key={idx}
              className={styles.tabListItem}
              selectedClassName={styles.tabListItemActive}
            >
              {item.title}
            </Tab>
          ))}
        </TabList>
      </div>

      {content.map((item, idx) => (
        <TabPanel
          key={idx}
          className={classNames(styles.tabPanel, extraTabPanelClassName)}
          selectedClassName={styles.tabPanelActive}
        >
          {item.content}
        </TabPanel>
      ))}
    </Tabs>
  );
};
